import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Button, withWidth } from '@material-ui/core';
import styled from 'styled-components';
import classes from './Paginate.module.scss';
import { ChevronLeftOutlinedStyled, ChevronRightStyled } from './paginateicons';

const ChevronLeftOutlined = styled(ChevronLeftOutlinedStyled)`
  width: 32px;
  height: 32px;
  @media (min-width: 1280px) {
    width: 24px;
    height: 24px;
  }
`;
export const ChevronRight = styled(ChevronRightStyled)`
  width: 32px;
  height: 32px;
  @media (min-width: 1280px) {
    width: 24px;
    height: 24px;
  }
`;

const Pagination = (props) => {
  const { totalRecord, recordPerPage, currentPage, width, goToPage } = props;
  let pagesToShow = 0;
  let minShowPage = 0;
  let maxShowPage = 1;
  if (totalRecord % recordPerPage === 0) {
    pagesToShow = Math.floor(totalRecord / recordPerPage);
  } else {
    pagesToShow = Math.floor(totalRecord / recordPerPage) + 1;
  }
  // pagesToShow = 4;
  maxShowPage = currentPage + 3;
  maxShowPage = maxShowPage > pagesToShow ? pagesToShow : maxShowPage;
  if (currentPage > 3) {
    minShowPage = currentPage - 4;
  }
  const content = [];
  if (totalRecord === 0 || pagesToShow === 1) {
    return <></>;
  }
  const onNext = () => {
    goToPage(currentPage + 1);
  };
  const onBack = () => {
    goToPage(currentPage - 1);
  };
  const onSelect = (offset) => {
    goToPage(offset);
  };
  if (currentPage !== 1 || width === 'xs') {
    content.push(
      <Button
        className={classes.Button}
        onClick={(event) => {
          onBack(-1);
        }}
        disabled={currentPage === 1}
      >
        <ChevronLeftOutlined />
      </Button>
    );
  } else if (width === 'xs') {
    content.push(<div className={[classes.ButtonBox]} />);
  }

  if (currentPage > 4 && width !== 'xs') {
    content.push(
      <>
        <Button
          className={classes.Button}
          onClick={(event) => {
            onSelect(1);
          }}
        >
          1
        </Button>
        ...
      </>
    );
  }

  for (let i = minShowPage; i < maxShowPage; i++) {
    if (i + 1 !== currentPage && width !== 'xs') {
      content.push(
        <Button
          className={classes.Button}
          onClick={(event) => {
            onSelect(i + 1);
          }}
        >
          {i + 1}
        </Button>
      );
    } else if (i + 1 === currentPage) {
      content.push(
        <Button
          className={[classes.Button, classes.selected].join(' ')}
          selected
          onClick={(event) => {
            onSelect(i + 1);
          }}
        >
          {i + 1}
        </Button>
      );
    }
  }

  if (maxShowPage < pagesToShow) {
    content.push(
      <>
        ...
        <Button
          className={classes.Button}
          selected
          onClick={(event) => {
            onSelect(pagesToShow);
          }}
        >
          {pagesToShow}
        </Button>
      </>
    );
  }

  if (currentPage !== pagesToShow) {
    content.push(
      <Button
        className={classes.Button}
        onClick={(event) => {
          onNext(1);
        }}
        id="transactions-next-page"
      >
        <ChevronRight />
      </Button>
    );
  } else {
    content.push(
      <Button className={classes.Button} disabled id="transactions-next-page">
        <ChevronRight />
      </Button>
    );
  }
  return (
    <Grid
      className={classes.Pagination}
      style={{ marginTop: 20, marginBottom: 20 }}
      item
      xs={12}
      container
      justify="center"
    >
      {content.map((component, i) => (
        <Grid item key={i}>
          {component}
        </Grid>
      ))}
    </Grid>
  );
};

export default withWidth()(Pagination);

Pagination.propTypes = {
  offset: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  totalRecord: PropTypes.number.isRequired,
  recordPerPage: PropTypes.number,
};
